import React, { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';

import {
  InputQuestion,
  SelectQuestion,
} from 'scenes/common/components/Questions';
import { SlideIn, SubmitButton } from 'components';
import { InsuredItem, SingleSelectStepProps } from 'scenes/common/types';

const MORTGAGE_PROVIDER = 'mortgageProvider';
const MORTGAGE_PROVIDER_OTHER = 'mortgageProviderOther';
const OTHER = 'Other';

const MAX_OTHER_LENGTH = 30;

export const HELP_TEXT =
  'A certificate of currency will be automatically included in your policy documents and can also be accessed from our online Insurance Service Centre.';
export const QUESTION_NAME_OF_LENDER = 'Name of lender';

export const MortgageProviderStep: FunctionComponent<
  Pick<SingleSelectStepProps, 'defaultStateValue' | 'onNext' | 'options'> & {
    mortgageProviderOtherDefaultValue: string;
    insuredItem: InsuredItem;
  }
> = ({
  defaultStateValue,
  onNext,
  options,
  mortgageProviderOtherDefaultValue,
  insuredItem,
}) => {
  const questionMortgageProvider = `Who is the ${insuredItem} mortgage with?`;

  const {
    formState: { isValid },
    handleSubmit,
    control,
    errors,
    watch,
  } = useForm({
    mode: 'onChange',
  });

  const watchedMortgageProvider = watch(MORTGAGE_PROVIDER, defaultStateValue);

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <SelectQuestion
        options={options}
        control={control}
        stateKey={MORTGAGE_PROVIDER}
        question={questionMortgageProvider}
        defaultValue={defaultStateValue}
        isLoading={false}
        helpText={HELP_TEXT}
        ariaRequired
      />

      {watchedMortgageProvider === OTHER && (
        <SlideIn>
          <InputQuestion
            errors={errors}
            control={control}
            stateKey={MORTGAGE_PROVIDER_OTHER}
            defaultValue={mortgageProviderOtherDefaultValue}
            maxLength={MAX_OTHER_LENGTH}
            validationRules={{ required: true }}
            question={QUESTION_NAME_OF_LENDER}
            ariaRequired
          />
        </SlideIn>
      )}
      <SubmitButton enabled={isValid}>Next</SubmitButton>
    </form>
  );
};

export default MortgageProviderStep;
